// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1ZF-e","colMin":"styles_colMin__3xDb2","colCheckbox":"styles_colCheckbox__e0S4A"};